import { Injectable } from "@angular/core";
import { LoadingController } from "@ionic/angular/lazy";
import { LangProvider } from "../lang/lang";

@Injectable({ providedIn: "root" })
export class UiFeedbackService {
  isLoading: boolean = false;
  private loading: any = null;

  constructor(
    private loadingCtrl: LoadingController,
    private lingua: LangProvider
  ) {}

  private getLabel(key: string): string {
    const lang = this.lingua.languageSelected;
    return (this.lingua as any)[`${key}_${lang}`] || (this.lingua as any)[`${key}_IT`] || '';
  }

  async registrazioneUtenteAlert() {
    this.loading = await this.loadingCtrl.create({
      spinner: "bubbles",
      duration: 10000,
      message: this.getLabel('alertLetturaDati'),
      translucent: true,
    });
    return await this.loading.present();
  }

  async mostraLoader(durata = 5000, senzaTesto = false) {
    this.isLoading = true;
    this.loading = await this.loadingCtrl.create({
      spinner: "bubbles",
      duration: durata,
      message: senzaTesto ? undefined : this.getLabel('alertLetturaDati'),
      translucent: true,
    });
    return await this.loading.present();
  }

  async mostraLoaderNoTesti() {
    this.loading = await this.loadingCtrl.create({
      spinner: "dots",
      duration: 5000,
      message: "",
      translucent: true,
    });
    return await this.loading.present();
  }

  async stoppaLoader() {
    this.isLoading = false;
    if (this.loading != null) {
      await this.loading
        .dismiss()
        .then(() => {
          this.loading = null;
        })
        .catch((e) => console.log(e));
    }
  }

  async invioPagamentoLoader() {
    this.loading = await this.loadingCtrl.create({
      spinner: "bubbles",
      duration: 12500,
      message: this.getLabel('alertPagamentoInCorso'),
      translucent: true,
    });
    return await this.loading.present();
  }

  async updateDatiLoader() {
    this.loading = await this.loadingCtrl.create({
      spinner: "bubbles",
      duration: 4500,
      message: this.getLabel('alertSalvataggioInCorso'),
      translucent: true,
    });
    return await this.loading.present();
  }
}
